import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { isAuthBypassEnabled } from "@/lib/authBypass";
import { fetchIsSuperAdmin } from "@/services/systemAdminService";

export function useSystemAdmin(): { isSystemAdmin: boolean; isLoading: boolean } {
  const { session } = useAuth();
  const userId = session?.user.id;
  const [isSystemAdmin, setIsSystemAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(Boolean(userId));

  useEffect(() => {
    let cancelled = false;

    if (isAuthBypassEnabled()) {
      setIsSystemAdmin(false);
      setIsLoading(false);
      return () => {
        cancelled = true;
      };
    }

    if (!userId) {
      setIsSystemAdmin(false);
      setIsLoading(false);
      return () => {
        cancelled = true;
      };
    }

    setIsLoading(true);
    void fetchIsSuperAdmin(userId).then((value) => {
      if (!cancelled) {
        setIsSystemAdmin(value);
        setIsLoading(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { isSystemAdmin, isLoading };
}
